import request from './api'

export class DescriptionService {
    async getScoringDescriptionOptions() {
        const response = await request({
            method: 'GET',
            url: `api/scoringdescriptionsoptions/descriptionlist`,
        });

        return response;

    }

    static get instance() {
        return descriptionService
    }


}

const descriptionService = new DescriptionService();

export default descriptionService;
